export default __webpack_public_path__ + "static/media/ci.ed341434.svg";